export const getAssetType = (
  url: string
): "image" | "video" | "pdf" | "unknown" => {
  if (!url) return "unknown";
  const extension = url.split(".").pop()?.split(/#|\?/)[0].toLowerCase() || "";
  const imageTypes = ["jpg", "jpeg", "png", "gif", "webp", "svg"];
  const videoTypes = ["mp4", "webm", "ogg", "mov", "avi"];
  const pdfTypes = ["pdf"];

  if (imageTypes.includes(extension)) return "image";
  if (videoTypes.includes(extension)) return "video";
  if (pdfTypes.includes(extension)) return "pdf";
  return "unknown";
};
